import script from "./UpTipsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpTipsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./UpTipsDialog.vue?vue&type=style&index=0&id=6c6347cc&lang=scss"
import "./UpTipsDialog.vue?vue&type=style&index=1&id=6c6347cc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6347cc"]])

export default __exports__